const VISITOR_SESSION_KEY = 'atirame_visitor_session_id'
const WIDGET_PHONE_KEY = 'chatUserPhone'

function readStorageValue(key: string): string | undefined {
  if (typeof window === 'undefined') return undefined
  try {
    const value = window.localStorage.getItem(key)?.trim()
    return value || undefined
  } catch {
    return undefined
  }
}

function ensureVisitorSessionId(): string | undefined {
  const existing = readStorageValue(VISITOR_SESSION_KEY)
  if (existing) return existing
  if (typeof window === 'undefined') return undefined

  const sessionId =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : `sess-${Date.now()}-${Math.random().toString(36).slice(2)}`

  try {
    window.localStorage.setItem(VISITOR_SESSION_KEY, sessionId)
  } catch {
    return sessionId
  }

  return sessionId
}

export function getLandingSubmissionContext() {
  return {
    sessionId: ensureVisitorSessionId(),
    widgetPhone: readStorageValue(WIDGET_PHONE_KEY),
  }
}
